export default "__VITE_ASSET__D$48SGnA__"